module.exports = __webpack_public_path__ + "img/email.827e9f94.svg";